import React, { ReactChild, HTMLAttributes } from 'react'

export interface ITableCellProps extends HTMLAttributes<HTMLTableCellElement>{
  children:  ReactChild | ReactChild[];
  variant?: 'head' | 'body' | 'footer';
  colspan?: number;
}
export default function TableCell({children, variant = "body", colspan = 1, ...props}: ITableCellProps)   {

  switch(variant) {
    case "head": {
      return (
        <th {...props} colSpan={colspan}>
          {children}
        </th>
      )
    }
    case "footer":
    case "body": {
      return (
        <td className='table_cell' {...props} colSpan={colspan}>
          {children}
        </td>
      )
    }
  }
}
